export default __webpack_public_path__ + "static/capital-one-e85a1cd6966f0d9dcac76ae732e2d897.svg";